import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { useDispatch } from 'react-redux';
// @ts-ignore Untyped module
import { updateOptimisticLockingForRequest } from 'ContentEditorUI/redux/actions/appActions';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import http from 'hub-http/clients/apiClient';
import usageTracker from 'ContentEditorUI/utils/UsageTracker';
import { userInfoSync } from 'hub-http/userInfo';
import I18n from 'I18n';
import useContentCrmObject from '../../hooks/useContentCrmObject';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import { PublishActionTypes } from '../../types/publishButtonTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const getContentCrmObjectDateTimeOptions = contentCrmObject => {
  const unpublishDate = getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_UNPUBLISH_DATE);
  const scheduledPublishDate = getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_PUBLISH_DATE);
  return {
    portalTimezone: userInfoSync().portal.timezone.id,
    scheduledTime: I18n.moment(scheduledPublishDate)
    // @ts-ignore portalTz() isn't typed
    .portalTz().format('LLL'),
    unpublishTime: I18n.moment(unpublishDate)
    // @ts-ignore portalTz() isn't typed
    .portalTz().format('LLL')
  };
};
const getAlertTitleTextAndMessage = actionTypeBodyInfoKey => {
  switch (actionTypeBodyInfoKey) {
    case 'scheduleUnpublish':
      return {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.success.title.scheduleUnpublish"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.success.message.scheduleUnpublish"
        })
      };
    case 'scheduleUpdate':
      return {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.success.title.scheduleUpdate"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.success.message.scheduleUpdate"
        })
      };
    default:
      return {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.success.title.schedulePublish"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.success.message.schedulePublish"
        })
      };
  }
};
const getConfirmModalCopy = (actionTypeBodyInfoKey, dateTimeCopyOptions) => {
  switch (actionTypeBodyInfoKey) {
    case 'scheduleUnpublish':
      return {
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.header.scheduleUnpublish"
        }),
        description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "cancelScheduleConfirmModal.body.scheduleUnpublish",
          options: dateTimeCopyOptions
        }),
        confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.footer.scheduleUnpublish"
        })
      };
    case 'scheduleUpdate':
      return {
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.header.scheduleUpdate"
        }),
        description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "cancelScheduleConfirmModal.body.scheduleUpdate",
          options: dateTimeCopyOptions
        }),
        confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.footer.scheduleUpdate"
        })
      };
    default:
      return {
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.header.schedulePublish"
        }),
        description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "cancelScheduleConfirmModal.body.schedulePublish",
          options: dateTimeCopyOptions
        }),
        confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.footer.schedulePublish"
        })
      };
  }
};
const CancelScheduleConfirmModal = ({
  closeModal,
  actionTypeBodyInfoKey
}) => {
  const dispatch = useDispatch();
  const {
    contentCrmObjectId,
    contentObjectType,
    contentCrmObject,
    reconcileContentCrmObjectForPublishActions
  } = useContentCrmObject();
  const dateTimeCopyOptions = getContentCrmObjectDateTimeOptions(contentCrmObject);
  const handleCancelScheduleWithCMP = () => {
    http.postWithResponse(`content-management/publication/v1/${contentObjectType}/${contentCrmObjectId}/schedule/${actionTypeBodyInfoKey === 'scheduleUnpublish' ? 'unpublish' : 'publish'}/async/cancel`).then(response => {
      FloatingAlertStore.addAlert(Object.assign({}, getAlertTitleTextAndMessage(actionTypeBodyInfoKey), {
        type: 'success'
      }));
      dispatch(updateOptimisticLockingForRequest({
        hasSaved: true,
        xLastModifiedTimestampHeader: response.headers['x-last-modified-timestamp']
      }));
      reconcileContentCrmObjectForPublishActions(actionTypeBodyInfoKey === 'scheduleUnpublish' ? PublishActionTypes.CANCEL_SCHEDULED_UNPUBLISH : PublishActionTypes.CANCEL_SCHEDULED_PUBLISH);
      usageTracker.track(actionTypeBodyInfoKey === 'scheduleUpdate' ? 'cancelUpdate' : 'cancelPublish');
      closeModal();
    }).catch(() => {
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.failure.title"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.failure.message"
        }),
        type: 'danger'
      });
    });
  };
  const {
    message,
    description,
    confirmLabel
  } = getConfirmModalCopy(actionTypeBodyInfoKey, dateTimeCopyOptions);
  return /*#__PURE__*/_jsx(ConfirmModal, {
    message: message,
    description: description,
    confirmLabel: confirmLabel,
    onConfirm: handleCancelScheduleWithCMP,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cancelScheduleConfirmModal.footer.exit"
    }),
    onReject: closeModal,
    size: "auto"
  });
};
export default CancelScheduleConfirmModal;